import { OTHER_TYPE } from './constants';
import * as SSTypes from '../../../constants/SSTypes';

export const allTypes = [
  OTHER_TYPE,
  SSTypes.SSBoolean,
  SSTypes.SSByte,
  SSTypes.SSChar,
  SSTypes.SSString,
  SSTypes.SSDateTime,
  SSTypes.SSInt32,
  SSTypes.SSInt16,
  SSTypes.SSInt64,
  SSTypes.SSSingle,
  SSTypes.SSDouble,
  SSTypes.SSDecimal,
];

export const relationalOperators = [
  {
    id: 'and',
    value: 'and',
    text: 'And',
  },
  {
    id: 'or',
    value: 'or',
    text: 'Or',
  },
];

const amountTypes = [
  OTHER_TYPE,
  SSTypes.SSString,
  SSTypes.SSDateTime,
  SSTypes.SSInt32,
  SSTypes.SSInt16,
  SSTypes.SSInt64,
  SSTypes.SSSingle,
  SSTypes.SSDouble,
  SSTypes.SSDecimal,
];
const nullableTypes = [
  OTHER_TYPE,
  SSTypes.SSChar,
  SSTypes.SSString,
  SSTypes.SSDateTime,
  SSTypes.SSInt32,
  SSTypes.SSInt16,
  SSTypes.SSInt64,
  SSTypes.SSSingle,
  SSTypes.SSDouble,
  SSTypes.SSDecimal,
];
const stringTypes = [OTHER_TYPE, SSTypes.SSChar, SSTypes.SSString];

const eqTypes = allTypes;
const ltTypes = amountTypes;
const lteqTypes = amountTypes;
const gtTypes = amountTypes;
const gteqTypes = amountTypes;
const neqTypes = allTypes;
const isnullTypes = nullableTypes;
const isnotnullTypes = nullableTypes;
const swTypes = stringTypes;
const ewTypes = stringTypes;
const ctTypes = stringTypes;

export default [
  {
    id: 'EQ',
    value: 'EQ',
    text: 'Is Equal To',
    validTypes: eqTypes,
  },
  {
    id: 'LT',
    value: 'LT',
    text: 'Is Less Than',
    validTypes: ltTypes,
  },
  {
    id: 'LTEQ',
    value: 'LTEQ',
    text: 'Is Less Than or Equal To',
    validTypes: lteqTypes,
  },
  {
    id: 'GT',
    value: 'GT',
    text: 'Is Greater Than',
    validTypes: gtTypes,
  },
  {
    id: 'GTEQ',
    value: 'GTEQ',
    text: 'Is Greater Than or Equal To',
    validTypes: gteqTypes,
  },
  {
    id: 'NEQ',
    value: 'NEQ',
    text: 'Not Equal To',
    validTypes: neqTypes,
  },
  {
    id: 'ISNULL',
    value: 'ISNULL',
    text: 'Is Null',
    validTypes: isnullTypes,
  },
  {
    id: 'ISNOTNULL',
    value: 'ISNOTNULL',
    text: 'Is Not Null',
    validTypes: isnotnullTypes,
  },
  {
    id: 'SW',
    value: 'SW',
    text: 'Starts With',
    validTypes: swTypes,
  },
  {
    id: 'EW',
    value: 'EW',
    text: 'Ends With',
    validTypes: ewTypes,
  },
  {
    id: 'CT',
    value: 'CT',
    text: 'Contains',
    validTypes: ctTypes,
  },
];
